import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { FieldName, ApplicationType } from '../Types/Intyg.enums';
import { RefSetter } from '../Utils/RefSetter';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';
import { IAppContext } from '../Types/Intyg.types';
import { MAX_LENGTH_NUM } from '../Services/intyg.validation.service';

export interface IPersonuppgifterProps {}
export interface IPersonuppgifterState extends FormSectionBaseState {}

export default class Personuppgifter extends FormSectionBase<IPersonuppgifterProps, IPersonuppgifterState> {
  constructor(props: IPersonuppgifterProps, context: IAppContext) {
    super(props);

    this.fieldRefs.set(FieldName.Epost, React.createRef<TextInput>());
    this.fieldRefs.set(FieldName.Bekraftaepost, React.createRef<TextInput>());

    if (context.applicationType === ApplicationType.Webform) {
      this.fieldRefs.set(FieldName.Personnummer, React.createRef<TextInput>());
      this.fieldRefs.set(FieldName.Fornamnn, React.createRef<TextInput>());
      this.fieldRefs.set(FieldName.Efternamn, React.createRef<TextInput>());
    }

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  webFormLayout = () => {
    const { Translate, formLanguage } = this.context;

    return (
      <RefSetter fieldRefs={this.fieldRefs}>
        <div className="row m-b-2">
          <div className="col-sm-6">
            <TextInput
              label={Translate('pnrorbirthday') + ' (obligatoriskt)'}
              fieldName={FieldName.Personnummer}
              isRequired={true}
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Personnummer)}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="off"
            />
          </div>
        </div>
        <div className="row m-b-2">
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Fornamnn)}
              label={Translate('fornamn') + ' (obligatoriskt)'}
              isRequired={true}
              fieldName={FieldName.Fornamnn}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="given-name"
            />
          </div>
          <div className={`col-sm-6`}>
            <TextInput
              onChange={this.onChangeField}
              errorMessage={this.getErrorMessage(FieldName.Efternamn)}
              label={Translate('efternamn') + ' (obligatoriskt)'}
              isRequired={true}
              fieldName={FieldName.Efternamn}
              maxLength={MAX_LENGTH_NUM}
              showMaxLengthMessage={true}
              maxLengthMessageLanguage={formLanguage}
              autoComplete="family-name"
            />
          </div>
        </div>
        {this.getEpostFields()}
      </RefSetter>
    );
  };

  eServiceLayout = () => {
    const { folkbokforing, isInEditMode } = this.context;

    if (isInEditMode) {
      return <div>Personuppgifter kommer här</div>;
    }

    return (
      <RefSetter fieldRefs={this.fieldRefs}>
        <div className="m-b-4">
          <div>{folkbokforing.Namn}</div>
          <div>{folkbokforing.PersonNummer}</div>
        </div>
        {this.getEpostFields()}
      </RefSetter>
    );
  };

  getEpostFields = () => {
    const { Translate, model, bekraftaepost, formLanguage } = this.context;
    return (
      <div className="row m-b-2">
        <div className={`col-sm-6`}>
          <TextInput
            onChange={this.onChangeField}
            errorMessage={this.getErrorMessage(FieldName.Epost)}
            isRequired={true}
            label={Translate('epost') + ' (obligatoriskt)'}
            fieldName={FieldName.Epost}
            maxLength={MAX_LENGTH_NUM}
            showMaxLengthMessage={true}
            maxLengthMessageLanguage={formLanguage}
            value={model.epost}
            autoComplete="email"
          />
        </div>
        <div className={`col-sm-6`}>
          <TextInput
            onChange={this.onChangeField}
            referenceValue={model.epost}
            errorMessage={this.getErrorMessage(FieldName.Bekraftaepost)}
            disablePaste={true}
            isRequired={true}
            label={Translate('epostbekraftelse') + ' (obligatoriskt)'}
            fieldName={FieldName.Bekraftaepost}
            maxLength={MAX_LENGTH_NUM}
            showMaxLengthMessage={true}
            maxLengthMessageLanguage={formLanguage}
            value={bekraftaepost}
            autoComplete="email"
          />
        </div>
      </div>
    );
  };

  public render() {
    const { applicationType, isInEditMode } = this.context;

    return (
      <section className="m-b-4">
        <EpiserverProperty propertyName="HeadingPersonuppgifter" isInEditMode={isInEditMode}>
          <h2>{this.findProperty('HeadingPersonuppgifter', 'personuppgifter')}</h2>
        </EpiserverProperty>
        {applicationType === ApplicationType.Webform && this.webFormLayout()}
        {applicationType === ApplicationType.Eservice && this.eServiceLayout()}
      </section>
    );
  }
}
